"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_utils_1 = require("@/components/common/button/button.utils");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
require("@/components/common/icon");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 북마크/즐겨찾기 토글 버튼.
 * 아이콘 전용이며 선택 시 채워진 아이콘으로 전환됩니다.
 */
let BookmarkButton = class BookmarkButton extends (0, button_utils_1.withTogglePressed)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.shape = 'star';
    }
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        aria-pressed=${this.pressed ? 'true' : 'false'}
        aria-label=${this.actionLabel}
        ?disabled=${this.disabled}
        @click=${this.handleToggleClick}
      >
        <mm-icon name=${this.iconName}></mm-icon>
      </button>
    `;
    }
    get iconName() {
        const filled = {
            star: icon_names_1.ICON_NAMES.FAVORITE_SELECTED,
            bookmark: icon_names_1.ICON_NAMES.BOOKMARK_SELECTED,
            heart: icon_names_1.ICON_NAMES.LIKE_SELECTED,
        };
        const outline = {
            star: icon_names_1.ICON_NAMES.FAVORITE,
            bookmark: icon_names_1.ICON_NAMES.BOOKMARK,
            heart: icon_names_1.ICON_NAMES.LIKE,
        };
        return this.pressed ? filled[this.shape] : outline[this.shape];
    }
    get actionLabel() {
        const labels = { star: '즐겨찾기', bookmark: '북마크', heart: '좋아요' };
        return labels[this.shape];
    }
};
BookmarkButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    icon_button_styles_1.iconButtonSelectedStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonVariantSkin)('ghost')}
        --icon-button-text-color: var(--foreground-subtle-color);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], BookmarkButton.prototype, "shape", void 0);
BookmarkButton = __decorate([
    (0, decorators_js_1.customElement)('mm-bookmark-button')
], BookmarkButton);
exports.BookmarkButton = BookmarkButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9va21hcmstYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYm9va21hcmstYnV0dG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsMEVBQTJFO0FBQzNFLG9FQUFnRTtBQUNoRSwyRkFJMkQ7QUFDM0Qsb0NBQWlDO0FBQ2pDLCtEQUF5RDtBQUV6RDs7O0dBR0c7QUFFSSxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsSUFBQSxnQ0FBaUIsRUFBQyxnQkFBVSxDQUFDO0lBQTFEOztRQVl1QixVQUFLLEdBQWtDLE1BQU0sQ0FBQTtJQWtDM0UsQ0FBQztJQWhDQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O3VCQUdRLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsT0FBTztxQkFDakMsSUFBSSxDQUFDLFdBQVc7b0JBQ2pCLElBQUksQ0FBQyxRQUFRO2lCQUNoQixJQUFJLENBQUMsaUJBQWlCOzt3QkFFZixJQUFJLENBQUMsUUFBUTs7S0FFaEMsQ0FBQTtJQUNILENBQUM7SUFFRCxJQUFZLFFBQVE7UUFDbEIsTUFBTSxNQUFNLEdBQUc7WUFDYixJQUFJLEVBQUUsdUJBQVUsQ0FBQyxpQkFBaUI7WUFDbEMsUUFBUSxFQUFFLHVCQUFVLENBQUMsaUJBQWlCO1lBQ3RDLEtBQUssRUFBRSx1QkFBVSxDQUFDLGFBQWE7U0FDaEMsQ0FBQTtRQUNELE1BQU0sT0FBTyxHQUFHO1lBQ2QsSUFBSSxFQUFFLHVCQUFVLENBQUMsUUFBUTtZQUN6QixRQUFRLEVBQUUsdUJBQVUsQ0FBQyxRQUFRO1lBQzdCLEtBQUssRUFBRSx1QkFBVSxDQUFDLElBQUk7U0FDdkIsQ0FBQTtRQUNELE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUNoRSxDQUFDO0lBRUQsSUFBWSxXQUFXO1FBQ3JCLE1BQU0sTUFBTSxHQUFHLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsQ0FBQTtRQUM5RCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDM0IsQ0FBQzs7QUE1Q00scUJBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gscUNBQWdCO0lBQ2hCLDZDQUF3QjtJQUN4QixJQUFBLFNBQUcsRUFBQTs7VUFFRyxJQUFBLDBDQUFxQixFQUFDLE9BQU8sQ0FBQzs7O0tBR25DO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NkNBQThDO0FBWjlELGNBQWM7SUFEMUIsSUFBQSw2QkFBYSxFQUFDLG9CQUFvQixDQUFDO0dBQ3ZCLGNBQWMsQ0E4QzFCO0FBOUNZLHdDQUFjIn0=